import Loading from 'components/Loading'
import React from 'react'
import { Helmet } from 'react-helmet'
import { useHistory } from 'react-router-dom'
import ErrorLabel from 'ui/atoms/ErrorLabel'
import { ZentakeContext } from 'utils/ZentakeContext'

import { setVerifyUser } from '../../api/auth'
import useQuery from '../../hooks/useQuery'
import {
  error,
  initial,
  isError,
  isInitial,
  isLoading,
  isSuccess,
  loading,
  success,
} from '../../utils/remoteData'
import AuthCard from './components/AuthCard'

const SECONDS_TO_REDIRECT = 4

function VerifyUser() {
  const [verifyUserRequest, setVerifyUserRequest] = React.useState(initial())
  const [countdown, setCountdown] = React.useState(SECONDS_TO_REDIRECT)
  const history = useHistory()
  const { updateUserDetails, userDetails } = React.useContext(ZentakeContext)

  const query = useQuery()
  const code = query.get('code')

  if (!code && isInitial(verifyUserRequest)) {
    setVerifyUserRequest(error('This link has expired'))
  }

  React.useEffect(() => {
    const timer = setTimeout(() => {
      if (userDetails?.is_verified) {
        if (countdown <= 0) {
          history.push('/')
        } else {
          setCountdown(countdown - 1)
        }
      }
    }, 1000)
    return () => clearTimeout(timer)
  }, [history, countdown, userDetails?.is_verified])

  React.useEffect(() => {
    async function fetchData() {
      if (code && isInitial(verifyUserRequest)) {
        try {
          setVerifyUserRequest(loading())
          const data = await setVerifyUser({ code })
          setVerifyUserRequest(success(data))
          await updateUserDetails()
        } catch (err) {
          setVerifyUserRequest(error('This link has expired'))
          throw err
        }
      }
    }
    fetchData()
  }, [code, history, updateUserDetails, verifyUserRequest])

  return (
    <>
      <Helmet>
        <title>Verify User/Zentake</title>
      </Helmet>
      {isSuccess(verifyUserRequest) || isLoading(verifyUserRequest) ? (
        <div className="w-full h-full overflow-hidden fixed top-0 left-0">
          <Loading />
        </div>
      ) : (
        <AuthCard>
          {isError(verifyUserRequest) && (
            <div className="flex flex-1 justify-center">
              <ErrorLabel>{verifyUserRequest.error}</ErrorLabel>
            </div>
          )}
        </AuthCard>
      )}
    </>
  )
}

export default VerifyUser
